import React from 'react';
import image from '@/public/images/rebates/3d-cash.webp';
import Image from 'next/image';
import { Icons } from '@/components/icons';

export const Rebates = () => {
  return (
    <div>
      <p className="mb-6 text-left text-lg font-normal">
        The Inflation Reduction Act offers significant tax breaks for
        energy-efficient home improvements. These include upgrades like new HVAC
        systems, solar panels, and more.
      </p>
      <p className="mb-6 text-left text-lg font-normal">
        Many of these incentives are already available, and even more will be
        rolled out by state and local governments in the coming years.
      </p>
      <p className="mb-6 text-left text-lg font-normal">
        Explore these opportunities to make your home greener and save on energy
        bills.
      </p>
      <div className="mx-auto my-8 max-w-[400px]">
        <Image src={image} alt="money" />
      </div>
      <p className="mb-10 text-3xl font-semibold">
        Summary of High-Efficiency Electric Rebates
      </p>
      <p className="mb-6 text-left text-lg font-normal">
        The Inflation Reduction Act (IRA) provides $4.275 billion to states and
        $225 million to tribal governments to create a high-efficiency electric
        home rebate program. These funds help low-income households (below 150%
        of the area&apos;s median income) upgrade their homes to use electricity
        more efficiently.
      </p>
      <p className="mb-6 text-left text-lg font-normal">
        Low-income households can receive a rebate covering 100% of project
        costs, up to certain limits. Households earning between 80% and 150% of
        the area&apos;s median income qualify for a 50% rebate, also up to the
        same limits.
      </p>

      <p className="mb-10 text-2xl font-medium">Key rebates include:</p>

      <ul className="mb-10">
        <li className="mb-5 flex items-center gap-4">
          <span>
            <Icons.checkIcon />
          </span>
          <span className="text-xl font-medium">
            $1,750 for a heat pump water heater
          </span>
        </li>
        <li className="mb-5 flex items-center gap-4">
          <span>
            <Icons.checkIcon />
          </span>
          <span className="text-xl font-medium">
            $8,000 for an HVAC heat pump
          </span>
        </li>
        <li className="mb-5 flex items-center gap-4">
          <span>
            <Icons.checkIcon />
          </span>
          <span className="text-xl font-medium">
            $840 for an electric stove, cooktop, or heat pump dryer
          </span>
        </li>
        <li className="mb-5 flex items-center gap-4">
          <span>
            <Icons.checkIcon />
          </span>
          <span className="text-xl font-medium ">
            $840 for an electric stove, cooktop, or heat pump dryer
          </span>
        </li>
        <li className="mb-5 flex items-center gap-4">
          <span>
            <Icons.checkIcon />
          </span>
          <span className="text-xl font-medium">
            {' '}
            $2,500 for electric wiring
          </span>
        </li>
        <li className="mb-5 flex items-center gap-4">
          <span>
            <Icons.checkIcon />
          </span>
          <span className="text-xl font-medium">
            $4,000 for an electric load center upgrade
          </span>
        </li>
      </ul>

      <p className="mb-6 text-left text-lg font-normal">
        There’s a <span className="font-semibold">$14,000</span> maximum benefit
        per home, with an additional <span className="font-semibold">$500</span>{' '}
        available for using a qualified contractor.
      </p>
      <p className="mb-10 text-2xl font-medium">
        Revamped Home Efficiency Tax Credits
      </p>

      <p className="mb-6 text-left text-lg font-normal">
        The IRA also extended the Efficiency Tax Credits. This means that
        eligible households can get a tax credit of up to $1,200 per year for
        energy-efficient upgrades. This includes things like weatherizing your
        home, improving your building envelope, and buying energy-efficient
        appliances. However, there are some caps on how much you can get back.
      </p>

      <ul className="mb-10">
        <li className="mb-5 flex items-start gap-4 text-left">
          <span>
            <Icons.checkIcon />
          </span>
          <span className="text-xl font-medium">
            $600 for Energy Star exterior windows and skylights
          </span>
        </li>
        <li className="mb-5 flex items-start gap-4 text-left">
          <span>
            <Icons.checkIcon />
          </span>
          <span className="text-xl font-medium">
            $250 for Energy Star exterior doors (or $500 limit for all exterior
            doors)
          </span>
        </li>
        <li className="mb-5 flex items-start gap-4 text-left">
          <span>
            <Icons.checkIcon />
          </span>
          <span className="text-xl font-medium">
            $600 for top-tier efficient central air conditioners, other
            qualified HVAC systems, and electrical upgrades for improved energy
            efficiency
          </span>
        </li>
        <li className="mb-5 flex items-start gap-4 text-left">
          <span>
            <Icons.checkIcon />
          </span>
          <span className="text-xl font-medium">
            $150 for home energy audits
          </span>
        </li>
        <li className="mb-5 flex items-start gap-4 text-left">
          <span>
            <Icons.checkIcon />
          </span>
          <span className="text-xl font-medium">
            {' '}
            $2,000 for electric heat pumps and heat pump water heaters, biomass
            stoves and boilers. The tax credit for installing heat pumps or heat
            pump water heaters does not count towards the annual $1,200 limit.
          </span>
        </li>
      </ul>
    </div>
  );
};
